'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/SignOut.es.js";
const t = a.forwardRef((e$1, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...e$1, weights: e }));
t.displayName = "SignOutIcon";
const c = t;
export {
  c as SignOut,
  t as SignOutIcon
};
